<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->

  <!-- DataTales Example -->
  <div class="card bg-white shadow mb-4">
    <!-- <div class="card-header bg-white">
      <h1 class="text-gray-800" style="display: inline-block">Company</h1>
      <button
        type="button"
        class="btn"
        style="float: right"
        [routerLink]="['/component','companies','company-add']"
      >
        Add Company
      </button>
    </div> -->
    <div class="card-body">
      <div class="table-responsive">
        <table
          datatable
          [dtOptions]="dtoptions"
          class="table table-bordered"
          width="100%"
          *ngIf="companys && companys.length > 0"
        >
         
          <thead>
            <tr>
              <th>Name</th>
             
            </tr>
          </thead>
        
          <tbody>
            <tr *ngFor="let company of companys">
              <td>
                <a
                  style="color: black"
                  (click)="navigate(company.Id)"
                  >{{ company.Name }}</a
                >
              </td>
             
            </tr>
          </tbody>
        </table>

        <p *ngIf="!companys || companys.length <= 0">No Company Found !</p>
      </div>
    </div>
  </div>
</div>
